import { Button, toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { medicalPaSubmission } from "../../../api/postCall/medicalPaSubmission";
import { ToastMessages } from "../../../components/toasts/toastMessages";
import { AlertTriangleIcon } from "../../../svg/alertTriangle";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";

const ErrorComponent = () => {
  const { id } = useParams();
  const [retryLoading, setRetryLoading] = useState(false);

  const handleRetryClick = async () => {
    setRetryLoading(true);
    try {
      await medicalPaSubmission(
        id ?? "",
        getOrgIdForFetchExternalWorklist(),
        undefined,
      );
      toast.success(ToastMessages.QUESTIONNAIRE_UPDATED_SUCCESS);
    } catch (error) {
      toast.error(ToastMessages.QUESTIONNAIRE_UPDATED_ERROR);
    } finally {
      setRetryLoading(false);
    }
  };

  return (
    <div className="error-component flex h-full w-full flex-col items-center justify-center gap-2">
      <div className="error-icon">
        <AlertTriangleIcon height={48} width={48} />
      </div>
      <div className="error-message text-center text-h11 font-semiBold text-primaryGray-1">
        Unable to load the questionnaire.
        <br />
        <span className="text-tiny text-gray-600">
          The required mapping is not found.
        </span>
      </div>
      <Button
        buttonType="secondary"
        size="small"
        disabled={retryLoading}
        onClick={handleRetryClick}
      >
        {retryLoading ? "Retrying..." : "Retry"}
      </Button>
    </div>
  );
};

export default ErrorComponent;
